import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DetailHeaderSkeleton = () => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
      <div className="flex items-start gap-4">
        <Skeleton width={40} height={40} borderRadius={8} />
        <div className="flex items-center gap-4 min-w-0">
          <Skeleton width={64} height={64} borderRadius={16} />
          <div>
            <div className="flex items-center gap-3">
              <Skeleton width={200} height={28} />
              <Skeleton width={80} height={24} borderRadius={9999} />
            </div>
            <Skeleton width={240} height={16} className="mt-2" />
          </div>
        </div>
      </div>
      <Skeleton width={140} height={40} borderRadius={8} />
    </div>
  );
};

export default DetailHeaderSkeleton;
